"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApocalypseAbilityHandler = exports.ApocalypseActorAbilityFactory = exports.ApocalypseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ApocalypseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Apocalypse;
        this.__typeName = "Apocalypse";
    }
}
exports.ApocalypseAbilityArgs = ApocalypseAbilityArgs;
let ApocalypseActorAbilityFactory = class ApocalypseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Apocalypse", "OneEnemies", 4);
    }
};
ApocalypseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Apocalypse")
], ApocalypseActorAbilityFactory);
exports.ApocalypseActorAbilityFactory = ApocalypseActorAbilityFactory;
let ApocalypseAbilityHandler = class ApocalypseAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Holy", 100)
            ],
            onHitOrMiss: (sequence, { hit }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "RainOfSwords"));
            },
        });
    }
};
ApocalypseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Apocalypse)
], ApocalypseAbilityHandler);
exports.ApocalypseAbilityHandler = ApocalypseAbilityHandler;
